import React, { useContext, useEffect } from 'react';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import messages from './VehicleMileage.message';
import VehicleMileageMetadata from './VehicleMileage.metadata.json5';

function SgVehicleMileage(props) {
    const {
        id,
        modelVM,
        updateData,
        showErrors,
        onValidate: onValidateParent,
        messageParams
    } = props;
    const {
        isComponentValid,
        onValidate
    } = useValidation(id);

    const translator = useContext(TranslatorContext);

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    const getAverageMiles = () => {
        // Weekly mileage calculation
        const mileage = modelVM.lobData.privateMotor.coverables.spmVehicle.mileage.value;
        let sum = 0;

        if (mileage.code <= 50000) {
            sum += (mileage.code - 500) / 52;
        }
        if (mileage.code > 50000) {
            sum += (mileage.code) / 52;
        }
        return translator(messages.averageMiles, { mileage: (Math.round(sum)).toString() });
    };

    const overrideProps = {
        mileage: {
            label: translator(messages.vehicleMileageLabel, { vehicle: messageParams.vehicle }),
            secondaryLabel: translator(messages.vehicleMileageSecondaryLabel, { vehicle: messageParams.vehicle })
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate,
        },
    };

    return (
        <>
            <ViewModelForm
                uiProps={VehicleMileageMetadata.componentContent}
                model={modelVM}
                showErrors={showErrors}
                onModelChange={updateData}
                onValidationChange={onValidate}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
            />
            { modelVM.lobData.privateMotor.coverables.spmVehicle.mileage.value !== undefined
                ? (
                    <div className="helpTextSlider sgHelpTextFixed">
                        {getAverageMiles()}
                    </div>
                )
                : null
            }
        </>

    );
}

export default SgVehicleMileage;
